import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProformaInvoiceEditLayer from "../components/ProformaInvoiceEditLayer";




const ProformaInvoiceEditPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Invoice - Edit" /> */}

        {/* InvoiceEditLayer */}
        <ProformaInvoiceEditLayer />

      </MasterLayout>

    </>
  );
};

export default ProformaInvoiceEditPage;
